// import Swiper from 'swiper';
// import { gsap } from 'gsap'

$ = jQuery;

$( document ).ready(function() {
  mygsap();
  menuUnclickTransform();
  removeText()
  burgerClick();
  menuScrolled();
  swiper();

  // if (window.innerWidth > 480){
    setTimeout(swiperResize, 500)
    
    // }
  subMenuClicked()
  window.addEventListener('resize', function() {
    subMenuClicked()
    swiperResize()
    // reinitialize()
   mygsap()
  });
});




function swiper(){
  var allSwiperContent = document.querySelectorAll('.swiper-content');
  for (let i = 0 ; i< allSwiperContent.length ; i++){
    let swiperID = allSwiperContent[i].getAttribute('id')
    contentSwiper(swiperID)
  }
  var swiperHeader = new Swiper('#swiper-header', {
    loop: true,
    autoplay: true,
    height: 500,
	speed : 500,
    pagination: {
      el: '.swiper-pagination',
      clickable: 'true'
    },
    breakpoints:{
      800:{
        height: 250
      }
    },
    paginationClickable : true
  });
  // console.log(swiperHeader);
  /* SWIPER PRODUKT */
  var swiperProdukt = new Swiper('#swiper-product', {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints:{
    480:{
      slidesPerView: 1,
    },
    800:{
      slidesPerView: 2,
    }
  },
  paginationClickable : true
  });


  var swiperProdukt = new Swiper('#swiper-highlights', {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints:{
      480:{
        slidesPerView: 1,
      },
      800:{
        slidesPerView: 2,
      }
    },
    paginationClickable : true
    });
  // console.log(swiperProdukt);
}

function contentSwiper(swiperName){
  let slides = document.querySelectorAll('#' + swiperName + ' .swiper-slide');
  let numberSlides = slides.length;
  if(slides.length > 3){
    numberSlides = 3;
  }
  var swipperWrapper = document.querySelector('#' + swiperName + ' .swiper-wrapper');
  
  var swiperName = new Swiper('#' + swiperName,{
    // loop: true,
    autoHeight: true,
    autoWidth: true,
    slidesPerView: numberSlides ,
    watchOverflow: true,
    spaceBetween : 20,
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints:{
      720:{
        slidesPerView: 2,
        pagination: {
          el: null,
        },
      },
      520:{
        slidesPerView: 1,
      },
    }
  });

}
function swiperResize(){
  var allSwiperContent = document.querySelectorAll('.swiper-content');
  for (let i = 0 ; i< allSwiperContent.length ; i++){
    let swiperID = allSwiperContent[i].getAttribute('id')
    slidesResize(swiperID)
  }
}


function slidesResize(swiperName){
  let slides = document.querySelectorAll('#' + swiperName + ' .swiper-slide');
  let wrapperWidth = document.querySelector('.wrapper').offsetWidth;
  let swipperWrapper = document.querySelector('#' + swiperName).firstElementChild;
  for (let i = 0; i<slides.length ; i++){
    // console.log(slides[i]);
    let width = slides[i].getAttribute('data-slide-width');
    let slideWidth = Math.round(((width/1096) * (wrapperWidth - 60)) - 10) + "px";
    // console.log(slideWidth);
    // console.log(width);
    slides[i].style.width = slideWidth;
    // console.log(slides[0].offsetHeight + "px");
    // console.log(slides[i]);

    // slides[i].style.height = slides[0].offsetHeight + "px";
    if (window.innerWidth > 480){
      slides[i].style.height = "auto"
      // console.log('hello');
    }
    else{
      slides[i].style.width = ((wrapperWidth - 60) - 10) + "px"
      slides[i].style.height = ((wrapperWidth - 60) - 10) - 60 + "px"
    }
  }
  // console.log(swipperWrapper);
  swipperWrapper.style.height = "auto";
  // swipperWrapper.style.height = slides[0].offsetHeight + "px";
}

function mygsap(){
  if(window.innerWidth > 992){
    $.each($("header .menu-item"), function(index, element) {
        var subMenu = $(element).children('.sub-menu');
        var tl = null;
        if(subMenu.length != 0) {
            tl = new TimelineLite({paused:true});
            
            tl.from(subMenu, .2, {height:0});
            
            element.subMenuAnimation = tl;
            
            $(element).hover(menuItemOver, menuItemOut);
        } 
    });
  function menuItemOver(e) {
    this.subMenuAnimation.play();

  } 
  function menuItemOut() {
      this.subMenuAnimation.reverse();
  }
}

}

function subMenuClicked(){
  if(window.innerWidth < 992){
    let subMenu = document.querySelectorAll('header .sub-menu')
    for (let i = 0; i< subMenu.length ; i++){
      subMenu[i].parentNode.addEventListener('click', function(event){
        subMenu[i].classList.toggle('active');
        subMenu[i].parentNode.classList.toggle('active');
      });
    }
  }
}

function menuUnclickTransform(){
  var elements = document.querySelectorAll('.unclickable')
  // console.log(elements);
  for (let i = 0 ; i<elements.length ; i++){
    let oldElement = elements[i].firstChild;
    // console.log(elements[i].firstChild.textContent);
    let newElement = document.createElement('span');
    newElement.textContent = oldElement.textContent;
    oldElement.parentNode.replaceChild(newElement, oldElement);
  } 
}

function burgerClick(){
  let myburger = document.querySelector('.burger-menu');
  let menuNav = document.querySelector('#menu-main-menu');
  let mainBody = document.querySelector('main');
  myburger.addEventListener('click', function(){
    // console.log(menuNav);
    let item = myburger.children
    for (let i = 0 ; i < item.length ; i++){
      item[i].classList.toggle('active');
    }
    menuNav.classList.toggle('active');
    mainBody.classList.toggle('active');
  });
}

function removeText(){
  var elements = document.querySelectorAll('.folge-uns .sub-menu .menu-item a, .shop a, .logo-ctc a, .logo-creativeID a, .logo-bdd a')
  for (let i = 0 ; i< elements.length ; i++){
    elements[i].textContent = '';
  }
}

// function reinitialize(){
//   /**Renitialize active menu. Fix potential bugs on resize Window */
//   let activeElements = document.querySelectorAll('.active')
//   for (let i = 0 ; i< activeElements.length ; i++){
//     activeElements[i].classList.remove('active')
//   }
// }

function menuScrolled(){
  function addScrolledClass(){
    let mainNav = document.querySelector('.nav-main')
    let menuNav = document.querySelector('#menu-main-menu ')
    let logoNav = document.querySelector('.header .logo')
    let shopButton = document.querySelector('.shop')
    if(window.scrollY > 0){
      mainNav.classList.add('scrolled');
      menuNav.classList.add('scrolled');
      shopButton.classList.add('scrolled');
      logoNav.classList.add('scrolled');
    }
    else{
      mainNav.classList.remove('scrolled');
      menuNav.classList.remove('scrolled');
      shopButton.classList.remove('scrolled');
      logoNav.classList.remove('scrolled');
    }
  }
  window.addEventListener('scroll', function(e) {
    addScrolledClass()
  });
  addScrolledClass()
}
